// extracted by mini-css-extract-plugin
var _1 = "BillingCreateView-module__animatedBackground--Fosgi";
var _2 = "BillingCreateView-module__billingNoticeContainer--aUL_n";
var _3 = "BillingCreateView-module__footer--RCynS";
var _4 = "BillingCreateView-module__meta--r5tof";
var _5 = "BillingCreateView-module__sectionWrapper--f07cq";
export { _1 as "animatedBackground", _2 as "billingNoticeContainer", _3 as "footer", _4 as "meta", _5 as "sectionWrapper" }
